import UserTraps from './UserTraps'
import enhance from './UserTraps.enhancer'

export default enhance(UserTraps)

export const userTrapColumns = [
  {
    width: 300,
    field: 'trapName',
    label: 'Trap Name',
    orderField: 'name',
    format: 'trapNameShort',
  },
  {
    width: 200,
    field: 'groupName',
    label: 'Group Name',
    format: 'groupName',
  },
  {
    width: 200,
    format: 'timeDate',
    field: 'lastSynced',
    label: 'Data last collected',
    helpText: 'Last time the trap was synced through the app'
  },
  {
    width: 150,
    align: 'flex-end',
    field: 'createdAt',
    label: 'Installed',
    format: 'fullDate'
  }
]



// WEBPACK FOOTER //
// ./src/components/organisms/UserTraps/index.js